import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { Routes } from '@/router';
import { LoyaltyExplainerModalState } from '@/components/modals/CmgLoyaltyExplainerModal/cmg-loyalty-explainer-modal';
import { AnalyticsEventCategory, AnalyticsEventAction, AnalyticsEventLabel } from '@/services/google/google-analytics.services';
import { ReferAFriendFooterContentFragment } from '@/models/cms';

@Component({
  name: 'CmgLoyaltyQuestions',
})
export default class CmgLoyaltyQuestions extends Vue {
  referAFriendFooter: ReferAFriendFooterContentFragment = {};

  get isRewardsReferralProgramEnabled(): boolean {
    return this.$appStore.state.featureFlags.featureFlags.isRewardsReferralProgramEnabled;
  }

  @Watch('isRewardsReferralProgramEnabled')
  async onRewardsReferralProgramEnabledChange(newValue: boolean) {
    if (newValue) {
      await this.$services.config.setReferAFriendFooter();
      this.referAFriendFooter = this.$services.config.getReferAFriendFooter() || {};
    }
  }

  onClickExplainRewards(event: any) {
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsLanding,
      action: AnalyticsEventAction.HowRewardsWorkCtaClick,
      label: AnalyticsEventLabel.RewardsLandHowRewardsWorkClick,
    });
    this.$services.ui.pushEventTargetAsLastSelectedElement(event);
    this.$services.ui.setModalVisibility('loyaltyExplainer', true, { state: LoyaltyExplainerModalState.Explainer });
    this.$services.ui.firstFocus();
  }

  onClickRequestPoints() {
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsLanding,
      action: AnalyticsEventAction.PointRequestClick,
      label: AnalyticsEventLabel.RewardsLandPointRequestClick,
    });
    this.$services.ui.nextFocus('retro-credit-landing');
    this.$router.push({ name: Routes.RetroCredit });
  }

  onClickFullTerms() {
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsLanding,
      action: AnalyticsEventAction.RewardsTermsClick,
      label: AnalyticsEventLabel.RewardsLandTermsClick,
    });
    window.open(this.$services.config.getRewardsTermsUrl(), '_blank');
  }

  onClickFAQ() {
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsLanding,
      action: AnalyticsEventAction.RewardsFaqClick,
      label: AnalyticsEventLabel.RewardsLandFaqClick,
    });
    window.open(this.$services.config.getFaqUrl(), '_blank');
  }

  get referAFriendTitle() {
    return this.referAFriendFooter?.title || 'REFER A FRIEND';
  }
  get referAFriendDescription() {
    return this.referAFriendFooter?.body || 'Earn points when your friends sign up through your link.';
  }
  get referAFriendCta() {
    return this.referAFriendFooter?.ctaButton || 'Refer a Friend';
  }

  onClickReferAFriend() {
    this.$services.ui.setModalVisibility('referAFriendModal', true);
  }
}
